"use client"

import { BanknoteArrowDown } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `BanknoteArrowDownIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const BanknoteArrowDownIcon = component(Icon)({ as: BanknoteArrowDown })
